export default {
  "name": "Some Are Saints",
  "slug": "some-are-saints",
  "path": "/some-are-saints",
  "componentName" : "SomeAreSaints",
  "category": "Projects",
  "parent": false,
  "isPublic": true
}